export const drawerActionType = {
    SET_DRAWER_TOOGLE: 'SET_DRAWER_TOOGLE',
    SET_SELECTED_DRAWER_MENU: 'SET_SELECTED_DRAWER_MENU',
}